import { locales } from '@visa/lib-locale';

/**
 * Creates dict of countryCode: country pairs, searches for
 * given countryCode in lib-locale locales array
 * and gives country obj or undefined
 * e.g. {
 *   name: 'locale.country.Argentina',
 *   iso_code: '032',
 *   code: 'AR',
 *   languages: [
 *     {
 *       name: 'Español',
 *       code: 'es'
 *     }
 *   ]
 * }
 * @param {!string} code e.g., "AR"
 * @returns {Object|undefined} country obj  or undefined
 */
const countryDict = {};
locales.locales.forEach(c => (countryDict[c.code] = c));
export default code => (countryDict[code] ? countryDict[code] : undefined);
